const selectors = {
	container: '.group-cuddle',
	item: '.group-cuddle__item',
};

const classNames = {
	active: 'group-cuddle__item--active',
};

document.querySelectorAll(selectors.container).forEach((group) => {
	const items = group.querySelectorAll(selectors.item);

	const handleItem = (e) => {
		const item = e.currentTarget;
		const itemIsActive = item.classList.contains(classNames.active);
		items.forEach((item) => item.classList.remove(classNames.active));
		if (!itemIsActive) item.classList.add(classNames.active);
	};

	items.forEach((item) => {
		item.addEventListener('click', handleItem);
	});
});
